/**
 * Shared UI + config for CSR pages (hub + 5 sub-pages).
 */
import {
    GraduationCap,
    HeartPulse,
    Sparkles,
    Trees,
    Briefcase,
    LifeBuoy,
    HeartHandshake,
} from 'lucide-react';

export const CSR_TIERS = [
    {
        key: 'education',
        label: 'Education Projects',
        icon: GraduationCap,
        blurb: 'Scholarships, digital classrooms and school infrastructure programs.',
    },
    {
        key: 'health',
        label: 'Health Projects',
        icon: HeartPulse,
        blurb: 'Eye camps, mobile health vans and preventive-care drives.',
    },
    {
        key: 'skill-development',
        label: 'Skill Development Projects',
        icon: Sparkles,
        blurb: 'Career yatras, aptitude testing and vocational training programs.',
    },
    {
        key: 'green-visionary',
        label: 'Green Visionary Projects',
        icon: Trees,
        blurb: 'Tree plantation, coastal restoration and eco-club initiatives.',
    },
    {
        key: 'employment',
        label: 'Employment Projects',
        icon: Briefcase,
        blurb: 'Placement drives, sector-focused skilling and job facilitation programs.',
    },
    {
        key: 'disaster',
        label: 'Disaster Projects',
        icon: LifeBuoy,
        blurb: 'Rapid-response relief, community kitchens and rehabilitation programs.',
    },
    {
        key: 'others',
        label: 'Others',
        icon: HeartHandshake,
        blurb: 'Women empowerment, senior wellness and other community welfare programs.',
    },
];
